// @ts-nocheck
import { createBrowserHistory, History } from '/data/landun/workspace/p-886b67fca2dd4cca8e715cc19519f511/src/node_modules/@umijs/runtime';

let options = {
  "basename": "/v2"
};
if ((<any>window).routerBase) {
  options.basename = (<any>window).routerBase;
}

// remove initial history because of ssr
let history: History = process.env.__IS_SERVER ? null : createBrowserHistory(options);
export const createHistory = (hotReload = false) => {
  if (!hotReload) {
    history = createBrowserHistory(options);
  }

  return history;
};

export { history };
